<h1>Fortune Cookie</h1>
<form [formGroup]="form" (ngSubmit)="onGetCookie()">

  <label for="numCookies">Number of Cookies:</label>
  <select id="numCookies" formControlName="cookieCount">
    <option value="1" selected>1</option>
    <option value="2">2</option>
    <option value="3">3</option>
    <option value="4">4</option>
    <option value="5">5</option>
  </select>

  <br><br>

  <button type="submit">Get Cookies</button>

</form> 

<br><br>
<hr>
<br><br>

<ul>
  <li  *ngFor="let cookie of cookies">
    <h3>{{cookie.cookie}}</h3>
  </li>
</ul>